<div class="bootstrap data-table">
    <table class="table" *ngIf="dataRows?.length > 0">
        <thead *ngIf="!hideHeader">
            <tr>
                <th *ngFor="let col of columns">{{ col.name }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of dataRows; let rowIndex = index"
                [style.height.px]="rowHeight">
                <td *ngFor="let col of columns">
                    <app-link-column *ngIf="col.type === 'link'"
                        [dataItem]="row"
                        [property]="col.property"
                        (keyFieldClick)="keyFieldClick.emit($event)">
                    </app-link-column>

                    <app-checkbox-column *ngIf="col.type === 'checkbox'"
                        [dataItem]="row"
                        [property]="col.property"
                        (itemChecked)="itemChecked.emit({item: $event, rowIndex: rowIndex})"
                        (itemUnchecked)="itemUnchecked.emit({item: $event, rowIndex: rowIndex})">
                    </app-checkbox-column>

                    <ng-container *ngIf="col.template">
                        <div [ngClass]="{'cell-contains-multiple-line-text': col.multipleLineTextDisplay}">
                            <ng-container [ngTemplateOutlet]="col.template"
                                [ngTemplateOutletContext]="{row: row, rowIndex: rowIndex}">
                            </ng-container>
                        </div>
                    </ng-container>

                    <span *ngIf="!col.type && !col.template">
                        {{ row[col.property] }}
                    </span>
                </td>
            </tr>
        </tbody>
    </table>

    <div *ngIf="paginationToken && !hideFooter"
        class="p-3 text-center">
        <a class="btn load-more-btn"
            (click)="loadMoreData(paginationToken)">
            Load More
        </a>
    </div>
</div>
